import { useState } from "react";
import "./MediaLanding.scss";
import { Link, Outlet } from "react-router-dom";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { useIntl } from "react-intl";

function MediaLanding() {

  const intl = useIntl();

  const [toggleState, setToggleState] = useState( window?.location?.pathname?.includes("/news") ? 1 :
    window?.location?.pathname?.includes("mediaLanding/media") ? 2 :
    window?.location?.pathname?.includes("magazine") ? 3 : 1)

  const [title, setTitle] = useState( window?.location?.pathname?.includes("/news") ? "news" :
    window?.location?.pathname?.includes("mediaLanding/media") ? "images-videos" :
    window?.location?.pathname?.includes("magazine") ?  "egyptian-statistical-review" : "news")

  const toggleTap = (index, title) => {
    setToggleState(index);
    setTitle(title);
  };

  // React.useEffect(() => {
  //   const timeOut = setTimeout(() => {
  //     window.scrollTo(0, 0);
  //   }, 0);
  //   return () => {
  //     clearTimeout(timeOut)
  //   }
  // }, [])

  return (
    <div className="MediaLanding">
      <InnerHeader
        breadcrumb={[
          {
            title: intl.formatMessage({ id: "media-center"}),
            clickClass: false,
          },
          {
            title: intl.formatMessage({ id: title}),
            clickClass: true,
          },
        ]}
        title= {intl.formatMessage({ id: "browse-archive" })}
        route={'../mediaLanding'}
      />
      <div className="sub-tab">
        <div className="container">
          <ul>
            <li>
              <Link to={"/mediaLanding/news"}>
                <span
                  onClick={() => toggleTap(1, "news")} 
                  className={toggleState === 1 ? "active" : ""}
                >
                  {intl.formatMessage({ id: "news"})}
                </span>
              </Link>
            </li>
            <li>
              <Link to={"/mediaLanding/media"}>
                <span
                  onClick={() => toggleTap(2, "images-videos")}
                  className={toggleState === 2 ? "active" : ""}
                >
                  {intl.formatMessage({ id: "images-videos"})}
                </span>
              </Link>
            </li>
            <li>
              <Link to={"/mediaLanding/magazine"}>
                <span
                  onClick={() => toggleTap(3, "egyptian-statistical-review")}
                  className={toggleState === 3 ? "active" : ""}
                >
                  {intl.formatMessage({ id: "egyptian-statistical-review"})}
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="container mb-4">
        <Outlet />
      </div>
    </div>
  );
}

export default MediaLanding;
